import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const Impressum = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1 className="legal-title">Impressum</h1>
        </div>
        <Card className="legal-card">
          <CardContent className="legal-content">
            <section className="legal-section">
              <h2>Angaben gemäß § 5 TMG</h2>
              <p>
                Atilla Ciftcioglu<br />
                Hüttenstraße 100<br />
                56170 Bendorf
              </p>
            </section>

            <section className="legal-section">
              <h2>Vertreten durch:</h2>
              <p>Atilla Ciftcioglu</p>
            </section>

            <section className="legal-section">
              <h2>Kontakt:</h2>
              <p>
                Telefon: 02622-9898654<br />
                E-Mail: info@pixel56.de
              </p>
            </section>

            <section className="legal-section">
              <h2>Umsatzsteuer-ID:</h2>
              <p>
                Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz: DE316853316
              </p>
            </section>

            <section className="legal-section">
              <h2>Allgemeiner Hinweis und Pflichtinformationen</h2>
              <h3>Benennung der verantwortlichen Stelle</h3>
              <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
              <p>
                pixel56<br />
                Atilla Ciftcioglu<br />
                Hüttenstraße 100<br />
                56170 Bendorf
              </p>
              <p>
                Die verantwortliche Stelle entscheidet allein oder gemeinsam mit anderen über die 
                Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, 
                Kontaktdaten o. Ä.).
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Impressum;
